import React, { useEffect, useState } from 'react';

import { Alert, Col, Form, Row } from 'react-bootstrap';

import BvcmRunReview from 'components/bvcm_review/BvcmRunReview';
import { BVCM_RUNS } from 'lib/networking/endpoints';
import Container from 'components/shared/Container';
import EmptyState from 'components/shared/EmptyState';
import FsaLoader from 'components/shared/FsaLoader';
import { runLabel } from 'components/bvcm_review/bvcmReview';
import useGet from 'lib/hooks/useGet';
import UserPermission from 'lib/enums/UserPermission';
import useUserPermissions from 'lib/hooks/useUserPermissions';

function BvcmReviewView() {
  const hasUserPermissions = useUserPermissions();
  const canReview = hasUserPermissions([UserPermission.ENRICH_PRODUCTS]);

  const {
    data: { data: runs = [] } = {},
    loading: runsLoading,
    error: runsError,
  } = useGet(BVCM_RUNS);

  const [runId, setRunId] = useState();
  useEffect(() => {
    if (!runId && runs.length) {
      setRunId(runs[0].id);
    }
  }, [runs, runId]);

  if (runsLoading) {
    return <FsaLoader label="Loading runs" fullView />;
  }

  return (
    <Container>
      <h3 className="font-weight-bold">Brand-Verified Code Mapping Review</h3>
      {runsError && <Alert variant="danger">Could not load the BVCM runs.</Alert>}
      {!runsError && runs.length === 0 && (
        <EmptyState
          title="No runs to review"
          description="A BVCM run appears here once it finishes and publishes its report."
        />
      )}
      {runs.length > 0 && (
        <Form.Group as={Row} className="mt-3">
          <Form.Label column md={1} htmlFor="bvcm-run">
            Run
          </Form.Label>
          <Col md={8}>
            <Form.Control
              id="bvcm-run"
              as="select"
              value={runId || ''}
              onChange={event => setRunId(Number(event.target.value))}
            >
              {runs.map(run => (
                <option key={run.id} value={run.id}>
                  {runLabel(run)}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Form.Group>
      )}
      {runId && <BvcmRunReview key={runId} runId={runId} canReview={canReview} />}
    </Container>
  );
}

export default BvcmReviewView;
